import type { GetPastDueInvoiceAlertsResult } from '@features/invoices/api/get-past-due-invoice-alerts/getPastDueInvoiceAlerts.types';
import type { UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@contexts/auth-provider/hooks/use-auth/useAuth';
import { useOrganizations } from '@contexts/organizations-provider';
import { getPastDueInvoiceAlerts } from '@features/invoices/api/get-past-due-invoice-alerts/getPastDueInvoiceAlerts';
import { useQuery } from '@tanstack/react-query';

interface UsePastDueInvoiceAlertsOptions {
  enabled?: boolean;
}

export function usePastDueInvoiceAlerts(
  options?: UsePastDueInvoiceAlertsOptions
): UseQueryResult<GetPastDueInvoiceAlertsResult, Error> {
  const { isAuthenticated } = useAuth();
  const { selectedOrganization } = useOrganizations();
  const organizationId = selectedOrganization?.id ?? '';

  return useQuery<GetPastDueInvoiceAlertsResult, Error>({
    queryKey: ['invoices', 'alerts', 'PastDueInvoices', organizationId],
    queryFn: () => getPastDueInvoiceAlerts({ organizationId }),
    enabled:
      isAuthenticated && !!selectedOrganization && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
